import { cva, type VariantProps } from 'class-variance-authority'
import React from 'react'

import BottomArrow from '@/legacy-src/components/pageBlocks/components/BottomArrow'
import { pageBlockColorVariants } from '@/legacy-src/components/pageBlocks/utils'
import { cn } from '@/legacy-src/lib/utils'

import { type PageBlockCommonType } from '../types'

type Props = VariantProps<typeof variants> & {
  children: React.ReactNode
  name?: string
  className?: string
  common?: PageBlockCommonType
  noBottomSpacing?: boolean
  isBusinessPage?: boolean
}

const variantsConfig = {
  color: {
    ...pageBlockColorVariants,
  },
  size: { default: 'py-14 tablet:py-24', minimal: '', sm: 'py-12 tablet:py-20', xs: 'py-8' },
}
const variants = cva('relative', {
  variants: variantsConfig,
  defaultVariants: { color: 'white', size: 'default' },
})

const PageBlock: React.FC<Props> = ({
  children,
  color: colorProps,
  size,
  name,
  className = '',
  noBottomSpacing,
  common,
  isBusinessPage,
}) => {
  const colorStrapi = common?.backgroundColor as any
  const isStrapiColorValid = Object.keys(variantsConfig.color).includes(colorStrapi)
  const color = isStrapiColorValid ? colorStrapi : colorProps

  const hideBottomSpacing = noBottomSpacing || common?.bottomSpacing === false

  return (
    <div
      className={cn(variants({ color, size }), className, hideBottomSpacing && '!pb-0')}
      data-block-name={name || 'unknown'}
    >
      {common?.sectionAnchor && <a className="relative -top-[100px] laptop:-top-[160px]" id={common.sectionAnchor} />}
      {children}
      {common?.bottomArrow && <BottomArrow isBusinessPage={isBusinessPage} />}
    </div>
  )
}

export default PageBlock
